import { useGetLaboratoryQuery } from "@/api/LaboratoryApi";
import { CircularProgress, Divider, Typography } from "@mui/material";
import { createFileRoute } from "@tanstack/react-router";
import OrganizationForm from "@components/annuaire/organizations/form/OrganizationForm.tsx";
import LaboratoryDocumentsSection from "@components/laboratory/documents/LaboratoryDocumentsSection.tsx";
import AppCard from "@components/AppCard.tsx";
import { requireRole } from "@/auth/requireRole.ts";
import { ROLE_ADMIN } from "@/constants";

export const Route = createFileRoute(
  "/_dashboard/annuaire/organizations/$uuid"
)({
  beforeLoad: (args) => {
    requireRole([ROLE_ADMIN])(args);
  },
  component: OrganizationsDetailsPage,
});

function OrganizationsDetailsPage() {
  const { uuid } = Route.useParams();

  const { data: laboratory, isLoading } = useGetLaboratoryQuery(uuid);

  if (isLoading) return <CircularProgress />;
  if (!laboratory) return null;

  return (
    <AppCard>
      <OrganizationForm
        type={"update"}
        laboratory={laboratory}
        onSuccess={() => {}}
        onCancel={() => window.history.back()}
      />
      <Divider sx={{ my: 3 }} />
      <Typography variant="h6" sx={{ mb: 2 }}>Certificats</Typography>
      <LaboratoryDocumentsSection laboratoryUuid={uuid} isAdmin />
    </AppCard>
  );
}
